import React, { useState } from "react";
import { Typography, IconButton, Box, TextField, Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  AccordionDetailsStyled,
  AccordionStyled,
  AccordionSummaryStyled,
} from "app/pages/components/mui/Accordions/StyledAccordion/StyleAccordion";
import BulkUpdateDialog from "../../../../components/BulkUpdateDialog";

const CompaniesAccordion = ({
  expanded,
  problemCompanies,
  handleAddCompany,
  handleDeleteCompany,
  handleCompanyChange,
  onChange,
  setProblemData,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const validateCompanies = (parsedCompanies) => {
    parsedCompanies.forEach((company, index) => {
      if (!company.companyName || !company.imageUrl) {
        throw new Error(
          `Company at index ${index} is missing companyName or imageUrl`
        );
      }
    });
  };

  const handleBulkUpdateCompanies = (parsedCompanies) => {
    setProblemData((prev) => {
      const updatedCompanies = parsedCompanies.map((company, idx) => ({
        id: `${Date.now()}-${idx}`, // Generate unique ID
        companyName: company.companyName,
        imageUrl: company.imageUrl,
      }));
      return {
        ...prev,
        problemCompanies: updatedCompanies.length > 0 ? updatedCompanies : null,
      };
    });
  };

  return (
    <>
      <AccordionStyled expanded={expanded} onChange={onChange}>
        <AccordionSummaryStyled
          expandIcon={<ExpandMoreIcon />}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography variant="subtitle1" sx={{ alignSelf: "center" }}>
            Companies
          </Typography>
          {expanded && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDialog(true);
                }}
              >
                Bulk Update
              </Button>
              <IconButton
                color="#475259"
                aria-label="Add Company"
                onClick={handleAddCompany}
                disabled={!expanded}
              >
                <AddIcon />
              </IconButton>
            </Box>
          )}
        </AccordionSummaryStyled>
        <AccordionDetailsStyled>
          {problemCompanies && problemCompanies.length > 0 ? (
            problemCompanies.map((company, index) => (
              <Box
                key={company.id || index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  mb: 2,
                  justifyContent: "space-between",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  padding: "16px",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <TextField
                    label="Company Name"
                    placeholder="Enter company name"
                    value={company.companyName || ""}
                    onChange={(e) =>
                      handleCompanyChange(index, "companyName", e.target.value)
                    }
                    sx={{ flex: 1 }}
                  />
                  <TextField
                    label="Image URL"
                    placeholder="Enter image URL"
                    value={company.imageUrl || ""}
                    onChange={(e) =>
                      handleCompanyChange(index, "imageUrl", e.target.value)
                    }
                    sx={{ flex: 1 }}
                    helperText="(e.g., https://example.com/image.jpg)"
                  />

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <IconButton
                      color="error"
                      aria-label="Delete Company"
                      onClick={() => handleDeleteCompany(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            ))
          ) : (
            <Typography>No companies available</Typography>
          )}
        </AccordionDetailsStyled>
      </AccordionStyled>

      <BulkUpdateDialog
        title="Bulk Update Companies"
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onBulkUpdate={handleBulkUpdateCompanies}
        validateInput={validateCompanies}
        successMessage="Companies added successfully!"
        helperText="Enter an array of companies in JSON format (e.g., [{ 'companyName': 'Amazon', 'imageUrl': 'https://example.com/image.jpg' }])"
      />
    </>
  );
};

export default CompaniesAccordion;
